import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchProductReviews = async () => {
  const response = await axiosInstance.get("product/review", {
    headers,
  });
  return response.data;
};

export const publishProductReview = async (id) => {
  return  await axiosInstance.patch(`product/review/${id}/publish`, {
    headers,
  });
};

export const unPublishProductReview = async (id) => {
  return await axiosInstance.patch(`product/review/${id}/unpublish`, {
    headers,
  });
};

export const markProductReviewFeatured = async (id) => {
  return  await axiosInstance.patch(`product/review/${id}/featured`, {
    headers,
  });
};

export const markProductReviewUnFeatured = async (id) => {
  return  await axiosInstance.patch(`product/review/${id}/unfeatured`, {
    headers,
  });
};

export const deleteProductReview = async (id) => {
  return await axiosInstance.delete(`product/review/${id}`, { headers });
};
